export class FamilyGroup {
  readonly id: string
  readonly name: string
  readonly owner_id: string
  readonly members_details: FamilyGroupMember[]

  constructor (id: string, name: string, owner_id: string, members_details: FamilyGroupMember[]) {
    this.id = id
    this.name = name
    this.owner_id = owner_id
    this.members_details = members_details
  }
}

export class FamilyGroupMember {
  readonly id: string
  readonly email: string

  constructor (id: string, email: string) {
    this.id = id
    this.email = email
  }
}
